import {
  BloodPressureCuffSize,
  DeviceDistributionMethod,
  deviceDistributionMethods,
} from "@/model/Prescription"

type PatientOptedInOption = {
  value: "yes" | "no"
  title: string
}

export const patientOptInValues: PatientOptedInOption[] = [
  {
    value: "yes",
    title: "Yes",
  },
  {
    value: "no",
    title: "No",
  },
]

type DeviceDistributionMethodOption = {
  value: DeviceDistributionMethod
  title: string
}

export const titleForDeviceDistributionMethod = (
  method: DeviceDistributionMethod
) => {
  switch (method) {
    case "home-delivery-or-reuse":
      return "Home delivery / reuse"
    case "from-provider":
      return "From provider"
  }
}

export const deviceDistributionMethodOptions: DeviceDistributionMethodOption[] =
  deviceDistributionMethods.map((method) => ({
    value: method,
    title: titleForDeviceDistributionMethod(method),
  }))

type CuffSizeOption = {
  value: BloodPressureCuffSize
  title: string
}

export const cuffSizes: CuffSizeOption[] = [
  {
    value: "S",
    title: "S",
  },
  {
    value: "M",
    title: "M",
  },
  {
    value: "L",
    title: "L",
  },
  {
    value: "XL",
    title: "XL",
  },
  {
    value: "XXL",
    title: "XXL",
  },
  {
    value: "PENDING",
    title: "Pending",
  },
]
